import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { ModalWithBackdrop, ModalWithBackdropProps } from '../ModalWithBackdrop/ModalWithBackdrop';
import styles from './ConfirmModal.module.css';
export type ConfirmModalProps = ModalWithBackdropProps & {
  /** default: Default */
  widthType?: ConfirmModalWidthType;
};
export enum ConfirmModalWidthType {
  Default = 'default',
  Auto = 'auto',
}
export const ConfirmModal: FunctionComponent<ConfirmModalProps> = React.memo(props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let children;
  let remainingProps;
  let t1;
  if ($[2] !== t0) {
    ({
      widthType: t1,
      children,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = children;
    $[4] = remainingProps;
    $[5] = t1;
  } else {
    children = $[3];
    remainingProps = $[4];
    t1 = $[5];
  }
  const widthType = t1 === undefined ? ConfirmModalWidthType.Default : t1;
  const t2 = widthTypeToClassName[widthType];
  let t3;
  if ($[6] !== t2) {
    t3 = classes(styles.dialog, t2);
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== t3) {
    t4 = <div className={t3}>{children}</div>;
    $[8] = children;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== remainingProps || $[12] !== t4) {
    t5 = <ModalWithBackdrop {...remainingProps}>{t4}</ModalWithBackdrop>;
    $[11] = remainingProps;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
});
const widthTypeToClassName: Record<ConfirmModalWidthType, string | null> = {
  [ConfirmModalWidthType.Default]: styles.widthTypeDefault,
  [ConfirmModalWidthType.Auto]: null
};